import * as React from 'react';
import { Provider } from 'react-redux';
import { ErrorLogComponent } from '@cian/error-log-component';
import { uaToDeviceType } from '@cian/ui-kit/utils';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { TReduxStore } from '../../types/redux';
import { ICustomContextParams } from '../../types/ICustomContextParams';
import { IApplicationContext } from '../../types/applicationContext';
import { ApplicationContext } from '../../utils';
import { Introduction } from '../Introduction';
import { FixedHeader } from '../FixedHeader';
import { About } from '../About';
import { Ratings } from '../Ratings';
import { Projects } from '../Projects';
import { ProjectsOnMap } from '../ProjectsOnMap';
import { Mortgage } from '../Mortgage';
import { VideoSection } from '../VideoSection';
import { News } from '../News';
import { InstagramSection } from '../InstagramSection';
import { Documentation } from '../Documentation';
import { SpecialPromos } from '../SpecialPromos';
import { Benefits } from '../Benefits';
import { MortgageCalculatorSection } from '../MortgageCalculatorSection';
import { MainContentWrapper } from '../../components/MainContentWrapper';
import { CallbackPopupContainer } from '../CallbackPopup';
import { AdfoxPixelContainer } from '../AdfoxPixel';

export interface IApplicationProps extends IApplicationContext {
  reduxStore: TReduxStore;
  customContext: ICustomContextParams;
}

export function Application(props: IApplicationProps) {
  const { config, logger, httpApi, reduxStore, customContext } = props;
  const getContext = React.useCallback(() => ({ config, logger, httpApi }), [config, httpApi, logger]);

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={getContext()}>
        <UiKitContextProvider deviceType={uaToDeviceType(customContext.userAgent)}>
          <Provider store={reduxStore}>
            <MainContentWrapper>
              <FixedHeader />
              <Introduction />
              <About />
              <MortgageCalculatorSection />
              <Ratings />
              <SpecialPromos />
              <Projects />
              <ProjectsOnMap />
              <Mortgage />
              <Benefits />
              <VideoSection />
              <News />
              <InstagramSection />
              <Documentation />
            </MainContentWrapper>
            <CallbackPopupContainer />
            <AdfoxPixelContainer />
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
}
